__turbopack_context__.v({
  "body": "_2SRNDq_body",
  "divider": "_2SRNDq_divider",
  "maintainer": "_2SRNDq_maintainer",
  "raisingFund": "_2SRNDq_raisingFund",
  "raisingFundTitle": "_2SRNDq_raisingFundTitle",
  "raisingFundWrapper": "_2SRNDq_raisingFundWrapper",
});
